module.exports = __webpack_public_path__ + "586dfc843acc9f686256bf07e134c591.svg";